import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { BuildLocationsForDropdown } from '../../api/models';

export type TABLE_TYPE = Table<BuildLocationsForDropdown>;

export const TABLE = 'buildLocationsForDropdown';
const SCHEMA = 'id';

class BuildLocationsForDropdownDatabase implements DataRepository<BuildLocationsForDropdown> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  // common methods:
  get(key: Key): Promise<BuildLocationsForDropdown | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: BuildLocationsForDropdown, key: Key): Promise<BuildLocationsForDropdown> {
    return this.db[TABLE].put(payload, key);
  }

  bulkAdd(payload: BuildLocationsForDropdown[]): Promise<BuildLocationsForDropdown[]> {
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<BuildLocationsForDropdown[]> {
    return this.db[TABLE].toArray();
  }
}

export const BuildLocationsForDropdownDB = new BuildLocationsForDropdownDatabase(db);
